import { FaAsterisk, /*FaCloud, FaDatabase,*/ FaTasks } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import styled, { useTheme } from 'styled-components';
import { getApps } from "../utils/appUtils";

const Container = styled.div`
  position: ${props => props.$isMobileView ? 'inherit' : 'fixed' };
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  width: 240px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  /* background: #ffffff; */
  background: ${({ theme }) => theme.backgrounds.pure };
  border-right: ${props => props.$isMobileView ? 'none' : props.theme.borders.main };
  margin-top: ${props => props.$isMobileView ? '0px' : '39px' };
`

const TabHeader = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  padding: 7px 15px;
  border-radius: 10px;
  font-size: 12px;
`

const TabDivider = styled.div`
  border-top: ${({ theme }) => theme.borders.main};
  margin: 5px 0px;
  opacity: 0.5;
`

export default ({
  isMobileView,
  setIsDrawerOpen,
  appRootPath
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const theme = useTheme();
  
  const itemStyle = {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    color: theme.colors.text,
    padding: '7px 15px',
    cursor: 'pointer',
    borderRadius: '10px',
    fontSize: '14px'
  }

  const selectedStyle = {
    background: theme.backgrounds.offPrimary,
    color: theme.colors.primary,
  }

  const getRoutePath = (path) => {
    const basePath = appRootPath === '/' ? '' : appRootPath;
    return path ? `${basePath}/${path}` : (appRootPath || '/');
  }

  const onItemClicked = (name, url) => {
    if (setIsDrawerOpen) {
      setIsDrawerOpen(false)
    }
    if (url) {
      window.open(url)
    }
    else {
      const path = getRoutePath(name)
      if (pathname !== path) {
        navigate(path);
      }
    }
  }

  const Tab = ({ icon, name, path, url, onClick }) => {
    const tabPath = getRoutePath(path);
    const extraStyle = pathname === tabPath ? selectedStyle : {};
    return (
      <div
        style={{
          ...itemStyle,
          ...extraStyle
        }}
        onClick={(e) => { 
          onItemClicked(path, url) 
          onClick?.(e)
        }}
      >
        <span style={{ display: 'flex', fontSize: '20px' }}>{icon}</span>
        <span>{name}</span>
      </div>
    )
  }

  const apps = getApps()

  return (
    <>
      <Container $isMobileView={isMobileView}>
        <TabHeader>Operations</TabHeader>
        <Tab name='Jobs' icon={<FaTasks />} path='' />
        {/*<Tab name='Jobs' icon={<FaTasks />} path='jobs' />*/}
        {/*<Tab name='AWS Jobs' icon={<FaCloud />} path='awsJobs' />*/}
        {/*<Tab name='Mongo Jobs' icon={<FaDatabase />} path='mongoJobs' />*/}
        <TabDivider />
        <TabHeader>Apps</TabHeader>
        {apps.map(a => 
          <Tab key={a.path} name={a.name} icon={<FaAsterisk />} path={`apps/${a.path}`} />
        )}
      </Container>
    </>
  )
}
